const msgList = () => import("@/pages/msg/list/index.vue");
const msgForm = () => import("@/pages/msg/list/form.vue");
const msgDetail = () => import("@/pages/msg/list/detail.vue");

export default [
    {
        path: "/msg/list",
        component: msgList,
        meta: [
            {
                name: "消息通知",
                activeRoute: "/msg/manage",
            },
            {
                name: "消息列表",
                activeRoute: "/msg/list",
            },
        ],
    },
    {
        path: "/msg/list/form",
        component: msgForm,
        meta: [
            {
                name: "消息通知",
                activeRoute: "/msg/manage",
            },
            {
                name: "消息列表",
                url: "/msg/list",
            },
            {
                name: "新增消息",
                activeRoute: "/msg/list",
            },
        ],
    },
    {
        path: "/msg/list/detail",
        component: msgDetail,
        meta: [
            {
                name: "消息通知",
                activeRoute: "/msg/manage",
            },
            {
                name: "消息列表",
                url: "/msg/list",
            },
            {
                name: "消息详情",
                activeRoute: "/msg/list",
            },
        ],
    },
];
